import axiosClient from "./axiosClient";

const tagApi = {
  getAll: (boardTypeId) => axiosClient.get(`tags/${boardTypeId}`),
  create: (params) => axiosClient.post("tags", params),
};

export default tagApi;
